import { useState } from "react";

export const useReportTypeOption = (defaultValue = "") => {
  const [selectedOption, setSelectedOption] = useState(defaultValue);

  const handleOptionChange = (e) => {
    setSelectedOption(e.target.value);
  };

  return { selectedOption, handleOptionChange };
};
